import Bet from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class IsWinOverThreshold extends Decision {
    public evaluate() {
        const win = GameState.getCurrentGame().getCurrentRecord().creditsWon / Bet.getTotalBet();

        const threshold = 0;

        return win > threshold ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/decisions/is-win-over-threshold.ts